import { getRequestFanHost } from "./fanFlowNavigation";

/** Fan routes where moment images should load before the recent-games list fetch. */
const MOMENT_HEAVY_FAN_PATHS = [
  "/my_moments",
  "/all_momento",
  "/moment",
  "/editor",
  "/momento_options",
  "/download_options",
];

/** Defer recent-games fetch on moment-heavy routes so it does not race Object Lambda image loads. */
export function shouldDeferRecentGamesFetch(): boolean {
  if (typeof window === "undefined") return false;
  const path = window.location.pathname.toLowerCase();
  return MOMENT_HEAVY_FAN_PATHS.some((segment) => path.includes(segment));
}

/** @deprecated Duplicate of `getRequestFanHost()` kept as a thin re-export; import that instead. */
export function getFanHostnamePrefix(): string {
  return getRequestFanHost();
}
